export const forBusiness_apparel_quality = [
	{
		icon: '💪',
		title: 'qualityData_title1',
		subtitle: 'qualityData_subtitle1',
	},
	{
		icon: '🚀',
		title: 'qualityData_title2',
		subtitle: 'qualityData_subtitle2',
	},
	{
		icon: '🤘',
		title: 'qualityData_title3',
		subtitle: 'qualityData_subtitle3',
	},
	{
		icon: '⭐️',
		title: 'qualityData_title4',
		subtitle: 'qualityData_subtitle4',
	},
];
